package one.primehealth.analytics.di

import one.primehealth.analytics.AppAnalytics
import one.primehealth.analytics.AppAnalyticsImpl
import one.primehealth.analytics.impl.AmplitudeAppAnalytics
import one.primehealth.analytics.impl.HltmAnalytics
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val analyticsModule = module {
    includes(platformModule)
    singleOf(::AmplitudeAppAnalytics)
    singleOf(::HltmAnalytics)
    singleOf(::AppAnalyticsImpl) bind AppAnalytics::class
}